const API_URL = import.meta.env.VITE_API_URL || '/api'

// Helper function for API calls
async function fetchApi(endpoint, options = {}) {
  const url = `${API_URL}${endpoint}`
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  }
  
  if (config.body && typeof config.body === 'object') {
    config.body = JSON.stringify(config.body)
  }
  
  const response = await fetch(url, config)
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }))
    throw new Error(error.error || `HTTP ${response.status}`)
  }
  
  return response.json()
}

// Task API
export const taskApi = {
  // Get all tasks
  getAll: (filters = {}) => {
    const params = new URLSearchParams(filters)
    return fetchApi(`/tasks?${params}`)
  },
  
  // Get today's tasks
  getToday: () => fetchApi('/tasks/today'),
  
  // Get upcoming tasks
  getUpcoming: (days = 7) => fetchApi(`/tasks/upcoming?days=${days}`),
  
  // Get single task
  getById: (id) => fetchApi(`/tasks/${id}`),
  
  // Create task
  create: (data) => fetchApi('/tasks', {
    method: 'POST',
    body: data,
  }),
  
  // Update task
  update: (id, data) => fetchApi(`/tasks/${id}`, {
    method: 'PUT',
    body: data,
  }),
  
  // Delete task
  delete: (id) => fetchApi(`/tasks/${id}`, {
    method: 'DELETE',
  }),
  
  // Toggle complete
  toggleComplete: (id) => fetchApi(`/tasks/${id}/toggle`, {
    method: 'PATCH',
  }),
  
  // Get categories
  getCategories: () => fetchApi('/tasks/categories/list'),
  
  // Parse natural language
  parseNaturalLanguage: (text) => fetchApi('/tasks/parse', {
    method: 'POST',
    body: { text },
  }),
  
  // Get stats
  getStats: () => fetchApi('/stats'),
  
  // Get productivity stats
  getProductivity: (days = 30) => fetchApi(`/stats/productivity?days=${days}`),
}

// Reminder API
export const reminderApi = {
  // Get all reminders
  getAll: (hours = 24) => fetchApi(`/reminders?hours=${hours}`),
  
  // Get due reminders
  getDue: () => fetchApi('/reminders/due'),
  
  // Create reminder
  create: (data) => fetchApi('/reminders', {
    method: 'POST',
    body: data,
  }),
  
  // Cancel reminder
  cancel: (id) => fetchApi(`/reminders/${id}/cancel`, {
    method: 'PATCH',
  }),
  
  // Delete reminder
  delete: (id) => fetchApi(`/reminders/${id}`, {
    method: 'DELETE',
  }),
}

// Health check
export const checkHealth = () => fetchApi('/health')